import { Text, View } from '@react-pdf/renderer';

import { Contract } from '@/types/ContractType';
import { styles } from '../style';

const TitleandSurvey = ({ contract }: { contract: Contract }) => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>TITLES, SURVEYS, AND COSTS</Text>

      <Text style={styles.text}>
        1. Within{' '}
        <Text style={styles.InfoText}>
          {contract?.thirdPartyTitleSettlement?.daysToSelectTitleCompany ||
            'N/A'}
        </Text>{' '}
        days from the Execution Date of this Agreement, Buyer will order from a
        reputable title company for delivery to Seller a comprehensive title
        report on the Property. Upon receipt, Buyer will deliver a free copy of
        the title report to Seller.
      </Text>

      <Text style={styles.text}>
        2. Buyer is encouraged to obtain an owner's title insurance policy to
        protect Buyer. An owner's title insurance policy is different from a
        lender's title insurance policy, which will not protect Buyer from
        claims and attacks on the title. Owner's title insurance policies come
        in standard and enhanced versions; Buyer should consult with a title
        insurance agent about Buyer's options. Buyer agrees to release and
        discharge any and all claims and losses against Broker for Buyer should
        Buyer neglect to obtain an owner's title insurance policy.
      </Text>

      <Text style={styles.text}>3. Buyer will pay for the following:</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          • Title search, title insurance and/or mechanics' lien insurance, or
          any fee for cancellation.
        </Text>
        <Text style={styles.listItem}>
          • Flood insurance, fire insurance, hazard insurance, mine subsidence
          insurance, or any fee for cancellation.
        </Text>
        <Text style={styles.listItem}>
          • Appraisal fees and charges paid in advance to mortgage lender.
        </Text>
        <Text style={styles.listItem}>
          • Buyer's customary settlement costs and accruals.
        </Text>
      </View>

      <Text style={styles.text}>
        4. Any survey or surveys required by the title insurance company or the
        abstracting company for preparing an adequate legal description of the
        Property (or the correction thereof) will be obtained and paid for by
        Seller. Any survey or surveys desired by Buyer or required by the
        mortgage lender will be obtained and paid for by Buyer.
      </Text>

      <Text style={styles.text}>
        5. The Property will be conveyed with good and marketable title that is
        insurable by a reputable title insurance company at the regular rates,
        free and clear of all liens, encumbrances, and easements, excepting
        however the following: existing deed restrictions; historic preservation
        restrictions or ordinances; building restrictions; ordinances; easements
        of roads; easements visible upon the ground; easements of record; and
        privileges or rights of public service companies, if any.
      </Text>

      <Text style={styles.text}>
        6. If a change in Seller's financial status affects Seller's ability to
        convey title to the Property on or before the Settlement Date, or any
        extension thereof, Seller shall promptly notify Buyer in writing. A
        change in financial status includes, but is not limited to, Seller
        filing bankruptcy; filing of a foreclosure lawsuit against the Property;
        entry of a monetary judgment against Seller; notice of public tax sale
        affecting the Property; and Seller learning that the sale price of the
        Property is no longer sufficient to satisfy all liens and encumbrances
        against the Property.
      </Text>

      <Text style={styles.text}>
        7. If Seller is unable to give good and marketable title that is
        insurable by a reputable title insurance company at the regular rates,{' '}
        <Text style={styles.DangerText}>
          Buyer may terminate this Agreement by written notice to Seller,
        </Text>{' '}
        with all deposit money returned to Buyer according to the terms of this
        Agreement, or take such title as Seller can convey. If the title
        condition precludes Seller from conveying title, Buyer's sole remedy
        shall be to terminate this Agreement. Upon termination, all deposit
        money shall be returned to Buyer according to the terms of this
        Agreement and Seller will reimburse Buyer for any costs incurred by
        Buyer for any inspections or certifications obtained according to the
        terms of this Agreement.
      </Text>
    </View>
  );
};

export default TitleandSurvey;
